import { createSlice } from '@reduxjs/toolkit'

export const loadingReducer = createSlice({
  name: 'loading',
  initialState:{
    value:false
  },
  reducers: {
    isloading: (state, action) => {
      state.value = action.payload
    },
   
  },
})

export const { isloading } = loadingReducer.actions

export default loadingReducer.reducer